import axios from "axios";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import qs from "qs";
import store from "@/shared/store";
import cacheInterceptor from "@/shared/utils/cache-interceptors-service";
import sse from "../../app/admin/system/ai/sse"
const baseURL = process.env.VUE_APP_BASEURL;
const $http = axios.create({
  baseURL: baseURL,
  timeout: 100000
});

$http.interceptors.request.use(
  config => {
    NProgress.start();
    const _cache = cacheInterceptor.check(config);
    if (_cache) {
      NProgress.done();
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      config.cancelToken = source.token;
      source.cancel({
        cached: true,
        data: _cache
      });
    }
    let t = $http.baseURL == 'java' ? 'Bearer ':'';

    console.log("sss"+$http.baseURL)
    config.baseURL =$http.baseURL == 'java' ?  process.env.VUE_APP_JAVA_BASEURL+'/v2':process.env.VUE_APP_BASEURL

    // console.log(config.baseURL)
    // console.log(process.env)
    // console.log(process.env.VUE_APP_JAVA_BASEURL)
    // config.headers["Content-Type"] = "application/x-www-form-urlencoded";

    if (store.getters.isLogin) {
      config.headers['Authorization'] = t+store.state.token;
    }
    if($http.baseURL == 'java'){
        // console.log("sky log application/json");
      config.headers['L-IdentityType'] =  'G-IE';
      config.headers['Content-Type'] =  'application/json';
    }else{
        // console.log("sky log application/x-www-form-urlencoded");
        config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }
    if (config.method != "get") {
      config.data = config.data || {};
      // config.data.source = 'IE';
        if($http.baseURL != 'java'){
            config.data = qs.stringify(config.data);
        }
    } else {
      config.params = config.params || config.params;
      // config.params.source = 'IE';
    }
    $http.baseURL ='';
    return config;
  },

  err => {
    Promise.reject(err);
  }
);

$http.interceptors.response.use(
  response => {
    NProgress.done();
    if(response.config && response.config.responseType == 'arraybuffer') {
      return response.data
    }
    if (response.data.code == "OK" || response.data.code == "SUCCESS" ) {
      cacheInterceptor.capture(response);
      return response.data.data;
    }else if(response.data.code == "0"){ //$http.baseURL == 'java' &&  java环境解析
        cacheInterceptor.capture(response);
        return response.data.data;
    }else {
      store.dispatch("pushMessage", response.data.message);
      return Promise.reject(response.data.message);
    }
  },
  err => {
    var a = { err };
    NProgress.done();
    if (err.__CANCEL__) {
      if (err.message.cached) {

        return Promise.resolve(err.message.data);
      }
    } else {
      store.dispatch("pushMessage", "网络超时，请稍后重试");
      return Promise.reject(err);
    }
  }
);
//新加的 java接口
$http.http =function(url,data=''){
  //console.log("http java")
  //console.log("http url "+url)
  //console.log("http api "+api)
  // $http.config = $http.config?$http.config:{}
  return sse.javaHttp.post(url,data)
  //console.log($http.baseURL)
};
export default $http;
